import React from 'react'
import { StyleSheet, TouchableOpacity, TouchableOpacityProps } from 'react-native'

import { Color } from '../../style'
import { Text } from '../typography'

const styles = StyleSheet.create({
  container: {
    width: 14,
    height: 14,
    borderRadius: 7,
    backgroundColor: Color.modifiedGrey,
    alignItems: 'center',
    justifyContent: 'center',
  },
  text: {
    margin: -15,
    padding: 15,
    fontSize: 10,
    lineHeight: 14,
    color: Color.simplyWhite,
  },
})

export interface Props extends TouchableOpacityProps {}
const HelpIcon = (props: Props) => {
  const { style, ...otherProps } = props
  return (
    <TouchableOpacity style={[styles.container, style]} testID="HelpIcon.Container" {...otherProps}>
      <Text style={styles.text}>?</Text>
    </TouchableOpacity>
  )
}

export default HelpIcon
